import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EmptyPageService {
  reviewAndPayTitle= "<span>You've already paid!</span>"
  invoiceNotFoundTitle= "<span>No invoices found</span>"
  reviewAndPayText = "<span>Thank you for your payment! You've already paid these invoices. Select 'Cancel & Go Back' to view any outstanding invoices.</span>";
  invoiceTitle = "<span>You don't have any unpaid invoices.</span>";
  invoiceText = "<span>After the first billing period, companyName will send you an email with the invoice and link to pay.</span>";
  invoiceTextWithCredits = '<span>You don’t have any unpaid invoices. ' +
    'After the first billing period, A-Team Accounting will send you an email with an invoice and a link to pay. ' +
    'If you have any available credits, they can be applied toward future invoices.</span>';
  invoiceNotFoundText = "<span>Please contact your firm finance contact if you feel this is a mistake.</span>";
  scheduledPaymentTitle = "<span>No scheduled payments found!<span>"
  scheduledPaymentText = "<span>You can find options to create them in the Settings page.</span>"
  previousPaymentsTitle = "<span>You haven't made any payments yet.</span>"
  previousPaymentsText = "<span>Payments made for invoices and recurring payments will show up here when you do.</span>"
}
